import React from "react";
import {
  IonItem,
  IonButton,
  IonIcon,
  IonLabel,
  IonList,
  IonAvatar,
  IonText,
  IonBadge,
} from "@ionic/react";
import { add } from "ionicons/icons";
import { Crew } from "../../context/CrewContext";

type Props = {
  crewsLoading: boolean;
  crewsFiltered: Crew[];
  searchLower: string;

  onCreateCrew: () => void;
  onOpenCrew: (crew: Crew) => void;

  getInitials: (name: string) => string;
};

export const CrewsListSection: React.FC<Props> = ({
  crewsLoading,
  crewsFiltered,
  searchLower,
  onCreateCrew,
  onOpenCrew,
  getInitials,
}) => {
  return (
    <div>
      <IonItem
        style={{ marginBottom: "25px" }}
        lines="none"
      >
        <IonButton
          size="small"
          slot="end"
          color="secondWarning"
          expand="block"
          onClick={onCreateCrew}
        >
          Create Crew
          <IonIcon
            icon={add}
            slot="end"
          />
        </IonButton>
      </IonItem>

      {crewsLoading ? (
        <IonItem
          lines="none"
        >
          <IonLabel
            color="medium"
          >
            Loading crews...
          </IonLabel>
        </IonItem>
      ) : crewsFiltered.length === 0 ? (
        <IonItem
          lines="none"
        >
          <IonLabel
            color="medium"
          >
            {searchLower ? "No matching crews." : "No crews yet."}
          </IonLabel>
        </IonItem>
      ) : (
        <IonList
          inset={true}
        >
          {crewsFiltered.map((crew) => (
            <IonItem
              key={crew.id}
              button={true}
              detail={true}
              onClick={() => onOpenCrew(crew)}
            >
              <IonAvatar
                slot="start"
              >
                {crew.avatarUrl ? (
                  <img
                    src={crew.avatarUrl}
                    alt={crew.name}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                ) : (
                  <div
                    style={{
                      width: "100%",
                      height: "100%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontWeight: 800,
                      fontSize: "14px",
                      background: "#e5e5e5",
                      color: "#333",
                    }}
                  >
                    {getInitials(crew.name)}
                  </div>
                )}
              </IonAvatar>

              <IonLabel
                className="ion-text-wrap"
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  <strong>{crew.name}</strong>
                </div>

                <IonText
                  color="medium"
                >
                  <div
                    style={{
                      marginTop: "2px",
                      overflow: "hidden",
                      display: "-webkit-box",
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical",
                      lineHeight: 1.2,
                    }}
                  >
                    {crew.description && crew.description.trim().length > 0
                      ? crew.description
                      : "No description"}
                  </div>
                </IonText>
              </IonLabel>

              <IonBadge
                slot="end"
                color="medium"
              >
                {crew.memberCount}
              </IonBadge>
            </IonItem>
          ))}
        </IonList>
      )}
    </div>
  );
};
